<template>
    <div class="data__sheet mb-13">
        <div class="hidden sm:block">
            <div class="nav_tabs flex mb-8">
                <!-- NAV DATA Description -->
                <div
                    class="nav_item mr-20"
                    @click.prevent="setActive('description')"
                    :class="{ active: isActive('description') }"
                >
                    <p
                        class="weight-500 md:tx-18 tx-grey-1 flex align-items-center m-0"
                    >
                        Descripción
                    </p>
                </div>
                <!-- NAV DATA SHEET -->
                <div
                    class="nav_item mr-20"
                    @click.prevent="setActive('dataSheet')"
                    :class="{ active: isActive('dataSheet') }"
                >
                    <p
                        class="weight-500 md:tx-18 tx-grey-1 flex align-items-center m-0"
                    >
                        Datos de vehículo
                    </p>
                </div>
                <!-- NAV features -->
                <div
                    class="nav_item"
                    @click.prevent="setActive('features')"
                    :class="{ active: isActive('features') }"
                >
                    <p
                        class="weight-500 md:tx-18 tx-grey-1 flex align-items-center m-0"
                    >
                        Características
                    </p>
                </div>
            </div>
            <!-- TABS -->
            <div class="tab_content h-full">
                <!-- TAB PANE DATA SHEET -->
                <div class="tab_pane" v-show="isActive('description')">
                    <div class="description">
                        {{
                            product.description
                                ? product.description
                                : "No se ha agregado una descripción"
                        }}
                    </div>
                </div>
                <!-- TAB PANE DATA SHEET -->
                <div class="tab_pane" v-show="isActive('dataSheet')">
                    <table
                        class="table__datasheet tx-14 xl:tx-16 spacing-0 border-collapse w-full mb-13"
                    >
                        <tr class="row" v-if="product.brand_id">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Marca
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ product.brand.title }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="product.model_id">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Modelo
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ product.model.title }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="product.version">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Versión
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ product.version }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="transmission">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Transmisión
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ transmission.title }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="color">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Color
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ color.title }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="condition">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Condición
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ condition.title }}
                                </span>
                            </td>
                        </tr>
                        <tr class="row" v-if="car_type">
                            <th class="heading w-2/4 tx-left">
                                <span>
                                    Tipo de auto
                                </span>
                            </th>
                            <td class="cell w-2/4 tx-right">
                                <span class="opacity-70">
                                    {{ car_type.title }}
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
                <!-- TAB PANE FEATURES -->
                <div class="tab_pane" v-show="isActive('features')">
                    <div class="list_features grid w-100" v-if="specs">
                        <div
                            class="item"
                            v-for="(spec, index) in specs"
                            :key="index"
                        >
                            <p
                                class="title weight-700 mb-0"
                                v-if="spec.category"
                            >
                                {{
                                    spec.value !== "serie" &&
                                    spec.value !== "-" &&
                                    spec.value !== "incluido" &&
                                    spec.value !== "si"
                                        ? spec.parentName + ", " + spec.name
                                        : spec.category + ", " + spec.parentName
                                }}
                            </p>
                            <p class="title weight-700 mb-0" v-else>
                                {{ spec.name }}
                            </p>
                            <p
                                class="tx-14 description m-0"
                                v-if="spec.category"
                            >
                                {{
                                    spec.value !== "serie" &&
                                    spec.value !== "-" &&
                                    spec.value !== "incluido" &&
                                    spec.value !== "si"
                                        ? spec.value
                                        : spec.name
                                }}
                            </p>
                            <p class="tx-14 description m-0" v-else>
                                {{ spec.value }}
                            </p>
                        </div>
                    </div>
                    <p
                        v-if="specs === null"
                        class="opacity-60 tx-14 md:tx-16 tx-center py-15 lg:py-30 m-0"
                    >
                        Contacta al vendedor para conocer más detalles
                    </p>
                </div>
            </div>
        </div>
        <div class="dropdown-list sm:hidden">
            <div class="dropdown" @click="activeDescription = !activeDescription">
                <div
                    class="flex justify-content-between align-items-center py-5"
                >
                    <span class="weight-500">
                        Descripción
                    </span>
                    <i
                        :class="{ 'rotate-180': activeDescription }"
                        class="fas fa-angle-down tx-20 tx-dark-ad transition-all-200"
                    ></i>
                    <!-- <img class="transition-all-200" width="12px" src="/assets/images/helpers/icon-angle-down_orange.svg" alt="" :class="{ 'rotate-180': activeDataSheet }"> -->
                </div>
                <transition name="slide-fade">
                    <div class="dropdown-contentp py-2" v-if="activeDescription">
                        <div class="description text-justify tx-14 py-4 px-6">
                            {{
                                product.description
                                    ? product.description
                                    : "No se ha agregado una descripción"
                            }}
                        </div>
                    </div>
                </transition>
            </div>
            <div class="dropdown" @click="activeDataSheet = !activeDataSheet">
                <div
                    class="flex justify-content-between align-items-center py-5"
                >
                    <span class="weight-500">
                        Datos de vehículo
                    </span>
                    <i
                        :class="{ 'rotate-180': activeDataSheet }"
                        class="fas fa-angle-down tx-20 tx-dark-ad transition-all-200"
                    ></i>
                    <!-- <img class="transition-all-200" width="12px" src="/assets/images/helpers/icon-angle-down_orange.svg" alt="" :class="{ 'rotate-180': activeDataSheet }"> -->
                </div>
                <transition name="slide-fade">
                    <div class="dropdown-contentp py-2" v-if="activeDataSheet">
                        <table
                            class="table__datasheet tx-14 xl:tx-16 spacing-0 border-collapse w-full"
                        >
                            <tr class="row" v-if="product.brand_id">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Marca
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ product.brand.title }}
                                        {{ product.model.title }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="product.model_id">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Modelo
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ product.model.title }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="product.version">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Versión
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ product.version }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="transmission">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Transmisión
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ transmission.title }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="color">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Color
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ color.title }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="condition">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Condición
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ condition.title }}
                                    </span>
                                </td>
                            </tr>
                            <tr class="row" v-if="car_type">
                                <th class="heading w-2/4 tx-left">
                                    <span>
                                        Tipo de auto
                                    </span>
                                </th>
                                <td class="cell w-2/4 tx-right">
                                    <span class="opacity-70">
                                        {{ car_type.title }}
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </transition>
            </div>
            <div class="dropdown" @click="activeFeatures = !activeFeatures">
                <div
                    class="flex justify-content-between align-items-center py-5"
                >
                    <span class="weight-500">
                        Características
                    </span>
                    <i
                        :class="{ 'rotate-180': activeFeatures }"
                        class="fas fa-angle-down tx-20 tx-dark-ad transition-all-200"
                    ></i>
                    <!-- <img class="transition-all-200" width="12px" src="/assets/images/helpers/icon-angle-down_orange.svg" alt="" :class="{ 'rotate-180': activeFeatures }"> -->
                </div>
                <transition name="slide-fade">
                    <div class="dropdown-content py-2" v-if="activeFeatures">
                        <div class="list_features grid w-100">
                            <div
                                class="item"
                                v-for="(spec, index) in specs"
                                :key="index"
                            >
                                <p
                                    class="title weight-700 mb-0"
                                    v-if="spec.category"
                                >
                                    {{
                                        spec.value !== "serie" &&
                                        spec.value !== "-" &&
                                        spec.value !== "incluido" &&
                                        spec.value !== "si"
                                            ? spec.parentName + ", " + spec.name
                                            : spec.category +
                                              ", " +
                                              spec.parentName
                                    }}
                                </p>
                                <p class="title weight-700 mb-0" v-else>
                                    {{ spec.name }}
                                </p>
                                <p
                                    class="tx-14 description m-0"
                                    v-if="spec.category"
                                >
                                    {{
                                        spec.value !== "serie" &&
                                        spec.value !== "-" &&
                                        spec.value !== "incluido" &&
                                        spec.value !== "si"
                                            ? spec.value
                                            : spec.name
                                    }}
                                </p>
                                <p class="tx-14 description m-0" v-else>
                                    {{ spec.value }}
                                </p>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        condition: {
            type: Object
        },
        color: {
            type: Object
        },
        transmission: {
            type: Object
        },
        car_type: {
            type: Object
        }
    },
    data() {
        return {
            activeItem: "dataSheet",
            activeDataSheet: false,
            activeFeatures: false,
            activeDescription: true
        };
    },
    methods: {
        isActive(menuItem) {
            return this.activeItem === menuItem;
        },

        setActive(menuItem) {
            this.activeItem = menuItem;
        }
    },
    computed: {
        specs() {
            if (this.product.specs === null) {
                return null;
            }
            return JSON.parse(this.product.specs.specs);
        }
    }
};
</script>
